import { render, staticRenderFns } from "./DocumentsFilterComponent.vue?vue&type=template&id=996675be&scoped=true&"
import script from "./DocumentsFilterComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentsFilterComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsFilterComponent.vue?vue&type=style&index=0&id=996675be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996675be",
  null
  
)

export default component.exports